export function isManagedDeviceFilter(DevicesService) {
  return function filter(device) {
    return DevicesService.isManagedDevice(device);
  }
}
